import axios from '../../http_v2'
let del = (data) => {
  return axios.post('activityservice/activitysort/delete', data)
}

let list = (data) => {
  return axios.post('activityservice/activitysort/list', data)
}

let add = (data) => {
  return axios.post('activityservice/activitysort/insert', data)
}

let update = (data) => {
  return axios.post('activityservice/activitysort/update', data)
}

export default {
  add,
  update,
  del,
  list
}
